import { SPACING } from "../constants";

export const MuiFormGroup = {
  root: {
    '.visit-information &': {
      marginLeft: `${SPACING * 6}px`, // Eyeballed to match Figma
    },
  },
};
